module.exports = __webpack_public_path__ + "static/img/my-class-bg2.8c9dac37.png";